import { render, staticRenderFns } from "./PortalDesignerDialog.vue?vue&type=template&id=2837082b&scoped=true&"
import script from "./PortalDesignerDialog.vue?vue&type=script&lang=js&"
export * from "./PortalDesignerDialog.vue?vue&type=script&lang=js&"
import style0 from "./PortalDesignerDialog.vue?vue&type=style&index=0&id=2837082b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2837082b",
  null
  
)

export default component.exports